import React, {
    useContext, useMemo
} from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { TranslatorContext } from '@jutro/locale';
import SpmConstants from 'sg-spm-constants';
import { CurrencyValue } from '@jutro/components';
import metadata from './SgExcessChangesTable.metadata.json5';
import messages from './SgExcessChangesTable.messages';

function SgExcessChangesTable(props) {
    const {
        changes,
        modelVM
    } = props;

    const translator = useContext(TranslatorContext);
    const { coverages } = modelVM.value.lobData.privateMotor.offerings[0].coverages.vehicleCoverages[0];

    const currentTerms = coverages.find((element) => element.patternCode === SpmConstants.BASIC_MOTOR_COVER_CODE).terms;

    const currentCompulsoryExcessValue = currentTerms.find((term) => term.patternCode === SpmConstants.COMPULSORY_AD_EXCESS_CODE).directValue;
    const currentVoluntaryExcess = currentTerms.find((term) => term.patternCode === SpmConstants.VOLUNTARY_AD_EXCESS_CODE);
    const currentVolExcessValue = currentVoluntaryExcess.options
        .find((option) => option.name === currentVoluntaryExcess.chosenTermValue).originalValueExt;

    const excessHeaders = useMemo(() => {
        return (
            <>
                {
                    !_.isNil(changes.fireAndTheftExcess)
                        ? (
                            <div>
                                {translator(messages.ExcessTableHeaderFT, { excess: changes.fireAndTheftExcess })}
                            </div>
                        )
                        : null
                }
                {
                    !_.isNil(changes.compulsoryExcess)
                        ? (
                            <div>
                                {translator(messages.ExcessTableHeader,
                                    { compulsory: changes.compulsoryExcess ? 'compulsory' : '', excess: changes.compulsoryExcess })}
                            </div>
                        )
                        : null
                }
            </>
        );
    }, [changes.compulsoryExcess, changes.fireAndTheftExcess, translator]);

    const overrideProps = {
        excessTableHeader: {
            content: excessHeaders
        },
        excessTable: {
            visible: !_.isNil(changes.compulsoryExcess) || !_.isNil(changes.voluntaryExcess),
            content: (
                <>
                    <div>
                        <p>
                            {translator(messages.Header)}
                        </p>
                    </div>
                    <table className="cepExcessesChangesTable">
                        <tbody>
                            <tr>
                                <td>{translator(messages.VoluntaryExcess)}</td>
                                <CurrencyValue
                                    currency="gbp"
                                    currencyDisplay="symbol"
                                    id="CurrencyValue"
                                    showFractions
                                    showGrouping
                                    tag="td"
                                    value={currentVolExcessValue}
                                />
                            </tr>
                            <tr>
                                <td>{translator(messages.CompulsoryExcess)}</td>
                                <CurrencyValue
                                    currency="gbp"
                                    currencyDisplay="symbol"
                                    id="CurrencyValue"
                                    showFractions
                                    showGrouping
                                    tag="td"
                                    value={currentCompulsoryExcessValue}
                                />
                            </tr>
                            <tr>
                                <td>{translator(messages.TotalExcess)}</td>
                                <CurrencyValue
                                    currency="gbp"
                                    currencyDisplay="symbol"
                                    id="CurrencyValue"
                                    showFractions
                                    showGrouping
                                    tag="td"
                                    value={currentCompulsoryExcessValue + currentVolExcessValue}
                                />
                            </tr>
                        </tbody>
                    </table>
                </>
            )
        },
    };

    const resolvers = {
        resolveCallbackMap: {},
        resolveComponentMap: {}
    };

    return renderContentFromMetadata(metadata.componentContent, overrideProps, resolvers);
}

export default SgExcessChangesTable;
